var map = {
	"./andersen-logo.svg": 34882,
	"./arrow.svg": 39778,
	"./astanahub-color.svg": 26435,
	"./astanahub-white.svg": 39706,
	"./calendar.svg": 58054,
	"./clock.svg": 68450,
	"./email.svg": 77468,
	"./letter-success.svg": 68088,
	"./linkedin.svg": 33423,
	"./marker.svg": 22137,
	"./mobile_astanahub-color.svg": 43555,
	"./mobile_astanahub-white.svg": 11981,
	"./mobile_qazaqit-color.svg": 34411,
	"./mobile_qazaqit-white.svg": 55682,
	"./phone.svg": 17796,
	"./qazaqit-color.svg": 86777,
	"./qazaqit-white.svg": 50271,
	"./select-arrow.svg": 4906,
	"./video-play-circle.svg": 51502,
	"./warning.svg": 79918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92498;